import { getMsgSiteList } from '@/common/api/normal.js'
export default {
  data() {
    return {}
  },
  methods: {
    _getMsgLists(param = {}) {
      // 查询未读的消息总条数 read 获取未读站内信条数 0未读 1 已读
      const params = Object.assign({}, { pageNo: 1, pageSize: 1, read: 0 }, param)
      const UUID = this.$Cookies.get('UUID')
      if (UUID) params.UUID = UUID
      if (params.UUID === undefined) return
      getMsgSiteList(params).then(([data, err, res]) => {
        if (!err) {
          if (this.publishInfo !== undefined) this.publishInfo = data.list
          if (params.read === 0) this.$store.commit('setInEmailNum', data.total)
        } else {
          if (params.read === 0) this.$store.commit('setInEmailNum', 0)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixin/getMsg.js